export const formFieldValue = {
    roomingId: "",
    customerId: "",
    civility: "",
    lastName: "",
    firstName: "",
    telephone: "",
    // telephoneCode: "",
    mobile: "",
    mobileCode: "",
    mail: "",
    birthDate: "",
    birthPlace: "",
    firstAddress: "",
    secondaryAddress: "",
    thirdAddress: "",
    zipCode: "",
    city: "",
    country: "",
    nationality: "",
    language: "",
    identityDocumentId: "",
    identityDocument: ""
};

export const formFieldPartOne = {
    lastName: {
        name: 'lastName',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    firstName: {
        name: 'firstName',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    mail: {
        name: 'mail',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    country: {
        name: 'country',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    }
};

export const formFieldPartTwo = {
    civility: {
        name: 'civility',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    firstAddress: {
        name: 'firstAddress',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    secondaryAddress: {
        name: 'secondaryAddress',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    thirdAddress: {
        name: 'thirdAddress',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    zipCode: {
        name: 'zipCode',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    city: {
        name: 'city',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    telephone: {
        name: 'telephone',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    // telephoneCode: {
    //     name: 'telephoneCode',
    //     required: false,
    //     typePattern: false,
    //     valueDefault: 0
    // },
    mobile: {
        name: 'mobile',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    mobileCode: {
        name: 'mobileCode',
        required: true,
        typePattern: false,
        valueDefault: 0
    },
    nationality: {
        name: 'nationality',
        required: true,
        typePattern: 'notNull',
        valueDefault: 0
    },
    language: {
        name: 'language',
        required: true,
        typePattern: 'notNull',
        valueDefault: 0
    },
    birthPlace: {
        name: 'birthPlace',
        required: true,
        typePattern:
            'notNull',
        valueDefault: ''
    },
    birthDate: {
        name: 'birthDate',
        required: true,
        typePattern: 'notNull',
        valueDefault: ''
    },
    identityDocumentId: {
        name: 'identityDocumentId',
        required: true,
        typePattern: 'notNull',
        valueDefault: 0
    },
    identityDocument: {
        name: 'identityDocument',
        required: true,
        typePattern: 'notNull',
        valueDefault: 0
    }
};

export const listErrorInputPartOne = {
    lastName: false,
    firstName: false,
    mail: false,
    country: false
}

export const listErrorInputPartTwo = {
    civility: false,
    lastName: false,
    firstName: false,
    telephone: false,
    // telephoneCode: false,
    mobile: false,
    mobileCode: false,
    mail: false,
    birthDate: false,
    birthPlace: false,
    firstAddress: false,
    secondaryAddress: false,
    thirdAddress: "",
    zipCode: false,
    city: false,
    country: false,
    nationality: false,
    language: false,
    identityDocument: false,
    identityDocumentId: false,
    signature: false,
    category: false
}
